import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SITE_ORIGIN, SITE_NAME, OG_IMAGE_PATH } from './siteMeta';

// Runtime head management for a single page. `path` must come from static
// config (route definitions), never window.location or query strings, so
// canonical URLs stay stable regardless of how the page was reached.
const Seo = ({ title, description, path = '/', noindex = false, jsonLd = [], imagePath }) => {
  const canonicalUrl = `${SITE_ORIGIN}${path}`;
  const imageUrl = `${SITE_ORIGIN}${imagePath || OG_IMAGE_PATH}`;

  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={canonicalUrl} />

      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:image" content={imageUrl} />

      <meta name="twitter:card" content="summary_large_image" />

      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {jsonLd.map((entry, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(entry)}
        </script>
      ))}
    </Helmet>
  );
};

export default Seo;
